// This file was automatically generated from print.nonvisitNote.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.nonvisitNote');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.core');
goog.require('el8.template.print');
goog.require('el8.template.ptdata.model.attachment');
goog.require('el8.template.ptdata.vitalsCollections');
goog.require('el8.template.util.format');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.nonvisitNote.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.nonvisitNote.title(opt_data, output);
  output.append('<div class="spacer"></div>');
  el8.template.print.nonvisitNote.body(opt_data.note, output);
  if (opt_data.note.signDate) {
    if (opt_data.note.signUserType == 'Physician') {
      el8.template.print.signature({localFsPath: opt_data.localFsPath, signPhysicianName: opt_data.note.signUserName, signDate: opt_data.note.signDate}, output);
    } else {
      el8.template.print.documentedBy(soy.$$augmentData(opt_data, {documentingStaffName: opt_data.note.signUserName, signDate: opt_data.note.signDate}), output);
    }
  }
  output.append('</div>');
  var imageList15751 = opt_data.note.fullSizeImages;
  var imageListLen15751 = imageList15751.length;
  for (var imageIndex15751 = 0; imageIndex15751 < imageListLen15751; imageIndex15751++) {
    var imageData15751 = imageList15751[imageIndex15751];
    output.append('<div class="pageWrap pageBreak">');
    el8.template.print.header(opt_data, output);
    el8.template.print.nonvisitNote.title(opt_data, output);
    output.append('<div style="overflow:hidden"><img class="previewItem el8MaxWidth100" src="', soy.$$escapeHtml(imageData15751), '" /></div><br/>');
    el8.template.print.patientInfoFooter(opt_data, output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.nonvisitNote.body = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.bullets.length == 1) {
    el8.template.core.textItem({text: opt_data.bullets[0].text}, output);
  } else {
    output.append('<ul class="list">');
    var bList15768 = opt_data.bullets;
    var bListLen15768 = bList15768.length;
    for (var bIndex15768 = 0; bIndex15768 < bListLen15768; bIndex15768++) {
      var bData15768 = bList15768[bIndex15768];
      output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(bData15768.text), '</li>');
    }
    output.append('</ul>');
  }
  if (opt_data.ownedDocuments.length) {
    output.append('<div class="spacer5"><h4>Orders:</h4><ul class="noAction">');
    var itemList15777 = opt_data.ownedDocuments;
    var itemListLen15777 = itemList15777.length;
    for (var itemIndex15777 = 0; itemIndex15777 < itemListLen15777; itemIndex15777++) {
      var itemData15777 = itemList15777[itemIndex15777];
      output.append('<li class="el8BulletText"><span class="el8Preserve">');
      el8.template.util.format.apply({formatting: itemData15777.summaryFormatting, text: itemData15777.summary}, output);
      output.append('</span></li>');
    }
    output.append('</ul></div>');
  }
  if (opt_data.associatedDocuments.length) {
    output.append('<div class="spacer5"><h4>Documents Referenced:</h4><ul class="noAction">');
    var itemList15788 = opt_data.associatedDocuments;
    var itemListLen15788 = itemList15788.length;
    for (var itemIndex15788 = 0; itemIndex15788 < itemListLen15788; itemIndex15788++) {
      var itemData15788 = itemList15788[itemIndex15788];
      output.append('<li class="el8BulletText"><span class="el8Preserve">');
      el8.template.util.format.apply({formatting: itemData15788.summaryFormatting, text: itemData15788.summary}, output);
      output.append('</span></li>');
    }
    output.append('</ul></div>');
  }
  if (opt_data.vitalsCollections.length) {
    output.append('<div class="spacer5"><h4>Vitals:</h4><ul class="noAction">');
    var itemList15799 = opt_data.vitalsCollections;
    var itemListLen15799 = itemList15799.length;
    for (var itemIndex15799 = 0; itemIndex15799 < itemListLen15799; itemIndex15799++) {
      var itemData15799 = itemList15799[itemIndex15799];
      output.append('<li class="el8BulletText"><span class="el8Preserve">');
      el8.template.ptdata.vitalsCollections.printSummary(itemData15799, output);
      output.append('</span></li>');
    }
    output.append('</ul></div>');
  }
  if (opt_data.attachments.length) {
    output.append('<div class="spacer5"><h4>Original File:</h4><ul class="noAction">');
    var itemList15808 = opt_data.attachments;
    var itemListLen15808 = itemList15808.length;
    for (var itemIndex15808 = 0; itemIndex15808 < itemListLen15808; itemIndex15808++) {
      var itemData15808 = itemList15808[itemIndex15808];
      output.append('<li class="el8BulletText"><span class="el8Preserve">');
      el8.template.ptdata.model.attachment.summary(itemData15808, output);
      output.append('</span></li>');
    }
    output.append('</ul></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.nonvisitNote.title = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="mt25 fr"><img src="', (opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '', '/static/images/logo_fax_300dpi.jpg', (! opt_data.localFsPath) ? '?v=20160729' : '', '" height="12" width="80"></p><h1 class="documentTitle">', (opt_data.note.type.name == 'phone') ? 'Phone ' : (opt_data.note.type.name == 'email') ? 'Email ' : '', 'Note</h1>');
  el8.template.print.patientInfoNotes({patient: opt_data.patient, timeOfPhrase: 'this note', displayPatientAge: opt_data.note.displayPatientAge}, output);
  output.append('<h3 class="reasonTitle">Date of Note: ', (soy.$$escapeHtml(opt_data.note.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.note.documentDate)) : ''), '</h3>');
  if (!opt_sb) return output.toString();
};
